import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

import { PayeeButtonsModule } from '../payee-buttons/payee-buttons.module';
import { PayeeFormFieldsModule } from '../payee-form-fields/payee-form-fields.module';
import { PayeeIconModule } from '../payee-icon/payee-icon.module';
import { PayeeInfoModule } from '../payee-info/payee-info.module';
import { CaseDetailsModule } from './case-details/cases-details.module';
import { CaseEventsModule } from './case-events/cases-events.module';
import { CaseStageFilterComponent } from './case-stage-filter/case-stage-filter.component';
import { CaseStartedAtFilterComponent } from './case-started-at-filter/case-started-at-filter.component';
import { CasesTableComponent } from './cases-table/cases-table.component';
import { PayeeCasesComponent } from './payee-cases.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { ChipDropdownComponent } from './chip-dropdown/chip-dropdown.component';
import { CaseReferenceIdFilterComponent } from './case-reference-id-filter/case-reference-id-filter.component';
import { CaseDebtorNameFilterComponent } from './case-debtor-name-filter/case-debtor-name-filter.component';

@NgModule({
  declarations: [
    CasesTableComponent,
    CaseStageFilterComponent,
    CaseStartedAtFilterComponent,
    PayeeCasesComponent,
    ChipDropdownComponent,
    CaseReferenceIdFilterComponent,
    CaseDebtorNameFilterComponent,
  ],
  imports: [
    CaseDetailsModule,
    CaseEventsModule,
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    PayeeButtonsModule,
    PayeeFormFieldsModule,
    PayeeIconModule,
    PayeeInfoModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    PayeeCasesComponent,
    ChipDropdownComponent,
  ],
})
export class PayeeCasesModule { }
